function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.5 0c-4.46 0-8.581 1.447-11.914 3.895C37.743 6.42 46.875 17.148 46.875 30c0 2.91-.468 5.712-1.334 8.334C52.633 35.246 57.589 28.199 57.589 20c0-11.046-8.994-20-20.089-20z",
  fill: "#FFDB00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.46 41.666C22.367 44.753 17.41 51.8 17.41 60c0 11.046 8.995 20 20.09 20 4.46 0 8.582-1.447 11.916-3.896C37.258 73.58 28.125 62.852 28.125 50c0-2.798.433-5.496 1.236-8.03z",
  fill: "#812BE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.286 20c0 12.852-9.133 23.581-21.29 26.105A20.063 20.063 0 0054.91 50C66.006 50 75 41.046 75 30c0-8.2-4.956-15.246-12.048-18.334A26.534 26.534 0 0164.286 20z",
  fill: "#FF6D00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.944 47.776A20.13 20.13 0 0034.821 50c0 11.046 8.995 20 20.09 20S75 61.046 75 50c0-.752-.042-1.494-.123-2.224a26.771 26.771 0 01-19.966 8.89 26.77 26.77 0 01-19.793-8.698z",
  fill: "#ED3987"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.09 10C8.993 10 0 18.954 0 30c0 .752.042 1.494.123 2.225a26.768 26.768 0 0119.966-8.892 26.771 26.771 0 0119.967 8.891c.08-.73.123-1.472.123-2.224 0-11.046-8.995-20-20.09-20z",
  fill: "#00CC95"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.09 30C8.993 30 0 38.954 0 50c0 8.2 4.956 15.247 12.049 18.334A26.515 26.515 0 0110.714 60c0-12.852 9.132-23.58 21.289-26.105A20.055 20.055 0 0020.089 30z",
  fill: "#157FF3"
}));

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 76 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLogo;